{
  "activeStudents": "Active students",
  "revenueThisMonth": "Revenue this month",
  "vsLastMonth": "Last month",
  "vsLastYear": "Same month last year",
  "outstanding": "Outstanding",
  "pending": "Pending",
  "overdue": "Overdue",
  "retentionRate": "Retention rate",
  "retention3": "3 months",
  "retention6": "6 months",
  "retention12": "12 months",
  "expenseBreakdown": "Expenses this month",
  "noExpenses": "No expenses recorded this month.",
  "recentActivity": "Recent activity",
  "viewAll": "View all",
  "noActivity": "No recent activity.",
  "needsAttention": "Needs attention",
  "allClear": "Yay, nothing boring to do",
  "overduePayments": "Overdue payments",
  "pendingOnboarding": "Students to onboard",
  "unconvertedEntries": "Entries need an exchange rate",
  "upcoming": "Upcoming",
  "noUpcoming": "Nothing scheduled yet.",
  "activity": {
    "studentCreated": "New student added",
    "statusChanged": "Student status changed",
    "levelChanged": "Student level changed",
    "paymentRecorded": "Payment recorded",
    "creditIssued": "Credit issued",
    "ledgerEntry": "Ledger entry added",
    "enrolled": "Student enrolled in a class",
    "eventCreated": "Event created"
  }
}
